/**
 * CommentRemove
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class CommentRemove {

	public onRemove: any;

	private $parent: any;

	private articleId: string;

	private _id: string;

	constructor( $parent: any, articleId: string ) {
		this.$parent = $parent;
		this.articleId = articleId;
		this.init();
	}

	private init() {
		this._id = this.$parent.attr( 'id' );
		this.articleId = this.articleId || Util.getParams().articleId;
		this.onRemove = new Util.Observer();
		this.addEvent();
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .btn-delete`, ( evt ) => {

			const $curr = evt.currentTarget;

			Config.confirm( Config.L10N.alert_delete_article, () => {
				const _$this = jQuery( $curr );
				const $removeNode = _$this.parent().parent();
				const isReply = $removeNode.hasClass( 'comment-article-reply' );
				const commentId = _$this.attr( 'data-commentid' );
				this.remove( commentId, $removeNode, isReply );
			}, () => {
				// reject
			});
		});
	}

	private setRemoveAndParentCommentCount( $removeNode: any, isReply: boolean ) {

		const $parent = $removeNode.prevAll( '.comment-article, .comment-article-delete' ).first();
		const $parentCount = $parent.find( '.co-btn-comments .text' );
		const count = parseInt( $parentCount.text(), 10 ) - 1;

		if ( isReply ) {
			( count && count > 0 ) ? $parentCount.text( count ) : $parentCount.text( 0 );
			$removeNode.remove();
		} else {
			$removeNode.replaceWith( Template.commentRemove() );
		}
	}

	private remove( commentId: string, $removeNode: any, isReply: boolean = false ) {
		const _data = {};
		// if( Config.isBnsApp ){
		// 	_data.c = commentId;
		// 	_data.boardName = Config.board;
		// 	_data.articleId = this.articleId;
		// }

		const _post = Util.get( Config.commentRemove({
			board: Config.board,
			articleId: this.articleId,
			commentId,
		}), 'DELETE', _data );
		const _post$ = Util.from( _post );
		_post$.subscribe( ( data: any ) => {
			this.setRemoveAndParentCommentCount( $removeNode, isReply );
			this.onRemove.emit();
		}, ( data: any ) => {
			Config.apiError( data );
		});
	}
}

export default CommentRemove;
